import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function BasicModal(prop) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // console.log(prop);

  let miti = prop.mitis;

  let old_dis_date = prop.display_history || [];
  let total_amount = prop.total_amount;
  let paid_amount =
    prop.paid_amount.length > 0
      ? prop.paid_amount.reduce((collect, current) => {
          return collect + current.amount;
        }, 0)
      : null;

  // console.log(paid_amount)
  // useEffect(() => {
  //   setmiti(prop.mitis);
  //   setold_dis_date(prop.display_history);
  // }, []);

  // const [miti, setmiti] = useState(false);
  // const [old_dis_date, setold_dis_date] = useState([]);

  // console.log(miti, "gf", old_dis_date);

  return (
    <div>
      {/* <Button onClick={handleOpen}>
        Display Info<span style={{ fontWeight: "600" }}>...</span>
      </Button> */}


      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div id="modal-modal-title">
            <div>{`${
              miti.regular?.type !== undefined
                ? `Regular:- days = ${miti.regular.days}, price = ${miti.regular.price}\n`
                : ""
            }`}</div>
            <div>{`${
              miti.Special?.type !== undefined
                ? `Special:- days = ${miti.Special.days}, price = ${miti.Special.price}\n`
                : ""
            }`}</div>
            <div>{`${
              miti.Olian?.type !== undefined
                ? `Olian:- days = ${miti.Olian.days}, price = ${miti.Olian.price}\n`
                : ""
            }`}</div>
            <div>{`${
              miti.sponsor?.type !== undefined
                ? `Sponsor:- days = ${miti.sponsor.days}, price = ${miti.sponsor.price}\n`
                : ""
            }`}</div>
            <div>{`${
              total_amount !== undefined ? `Total Amount = ${total_amount}` : ""
            }`}</div>
            <div>{`${
              paid_amount !== null ? `Paid Amount = ${paid_amount}` : ""
            }`}</div>
          </div>

          <hr></hr>
          <Box sx={{ overflow: "hidden" }}>
            {old_dis_date.length > 0 ? (
              <div className="model-table">
                <div className="model-head">
                  <div className="sirji1">S.N</div>
                  <div className="sirji2">Date</div>
                  <div className="sirji3">Name</div>
                </div>
                <div className="model-full-body">
                  {old_dis_date.map((e, i) => {
                    return (
                      <div className="model-body" key={i}>
                        <div className="sirji1">{i + 1}</div>
                        <div className="sirji2">{e.dis_date}</div>
                        <div className="sirji3">{e.dis_name}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <p>Not book any Date till now</p>
            )}
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
